import { BadgeOptions } from 'src/types';
import { PERIOD_VISITOR_CATEGORY, VISITOR_CATEGORY } from 'src/features/stay/types.ts';
import { ICON_MAP } from 'src/utils/constants.ts';
import { visitorMessages } from 'src/features/visitor/utils/messages.ts';
import { VISITOR_TYPE } from 'src/features/visitor/types.ts';

export const visitorCategoryBadgeOptions: BadgeOptions = {
    [PERIOD_VISITOR_CATEGORY.CLIENT]: {
        label: visitorMessages.client,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
    [PERIOD_VISITOR_CATEGORY.SUBSCRIPTION]: {
        label: visitorMessages.subscription,
        icon: ICON_MAP.SUBSCRIPTION,
        theme: 'orange',
    },
    [PERIOD_VISITOR_CATEGORY.RESERVATION]: {
        label: visitorMessages.reservation,
        icon: ICON_MAP.RESERVATION,
        theme: 'purple',
    },
    [PERIOD_VISITOR_CATEGORY.MEMBER]: {
        label: visitorMessages.member,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
};

export const visitorTypeBadgeOptions: BadgeOptions = {
    [VISITOR_TYPE.PERSON]: {
        label: visitorMessages.person,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
    [VISITOR_TYPE.CAR]: {
        label: visitorMessages.car,
        icon: ICON_MAP.CLIENT,
        theme: 'yellow',
    },
    [VISITOR_TYPE.BUS]: {
        label: visitorMessages.bus,
        icon: ICON_MAP.BUS,
        theme: 'purple',
    },
    [VISITOR_TYPE.TRUCK]: {
        label: visitorMessages.truck,
        icon: ICON_MAP.TRUCK,
        theme: 'green',
    },
    [VISITOR_TYPE.SPECIALISED]: {
        label: visitorMessages.specialised,
        icon: ICON_MAP.DANGER,
        theme: 'gray',
    },
};

export const visitorCategoryTranslationMap = {
    [VISITOR_CATEGORY.CLIENT]: visitorMessages.client,
    [VISITOR_CATEGORY.VIP]: visitorMessages.member,
    [VISITOR_CATEGORY.RESIDENT]: visitorMessages.member,
    [VISITOR_CATEGORY.STAFF]: visitorMessages.member,
    [VISITOR_CATEGORY.SERVICE]: visitorMessages.member,
    [VISITOR_CATEGORY.SUBSCRIPTION]: visitorMessages.subscription,
    [VISITOR_CATEGORY.RESERVATION]: visitorMessages.reservation,
    [VISITOR_CATEGORY.MEMBERSHIP]: visitorMessages.member,
};
